import React from "react"
import PropTypes from "prop-types"
import { toggle, setAll } from "../../redux/selection"
import { showSelectedOnly } from "../../redux/settings"
import { setParam, fetch } from "../../redux/query"
import store from "../../redux"
import { connect } from "react-redux"
import "./Dashboard.less"
import ReactJson from "react-json-view"
import { withRouter } from "../../lib/withRouter"
import ViewDashboardHeader from "./ViewDashboardHeader"
import Header2 from "../Header2"
import { getQuickSightUrl } from "../../lib"
import A1cDashboard from "./A1cDashboard"

export class Dashboard extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            populationQuickSightUrl: null,
            readmissionQuickSightUrl: null,
            adtTrackingQuickSightUrl: null,
            executiveEcmQuickSightUrl: null,
            leadershipQuickSightUrl: null,
            loading: false,
            error: null,
            activeTab: "populations"
        };
    }

    /** Callback to handle tab changes from ViewHeader */
    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
        this.props.dispatch(setParam("_resource", tabName));
    };

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);

        // CHECK REDIRECT TABS
        const _tab = query.get("_tab");
        if (["demographics", "conditions", "tags"].includes(_tab)) {
            query.delete("_resource");
            const clean = query.toString() ? `?${query.toString()}` : "";
            this.props.router.navigate(`/patient-list${clean}`);
            return;
        }

        // SET ACTIVE TAB
        const tab = query.get("_resource") || "populations";
        this.setState({ activeTab: tab }, () => {
            this.fetchDataForTab(tab);
        });
    }


    componentDidUpdate(prevProps, prevState) {
        // Check if activeTab changed
        if (prevState.activeTab !== this.state.activeTab) {
            this.fetchDataForTab(this.state.activeTab);
        }
    }

    fetchDataForTab = (tab) => {
        switch (tab) {
            case "populations":
                this.fetchPopulationsData();
                break;
            case "readmissions":
                this.fetchReadmissionData();
                break;
            case "adttracking":
                this.fetchAdtTrackingData();
                break;
            case "executiveecm":
                this.fetchExecutiveEcmData();
                break;
            case "leadership":
                this.fetchLeadershipData();
                break;

        }
    };

    fetchPopulationsData = async () => {
        console.log("Fetching populations data...");
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.baseUrl}/api/quicksight/embed-url`;
            console.log("API URL:", apiUrl);

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data && data.embedUrl) {
                this.setState({
                    populationQuickSightUrl: data.embedUrl,
                    loading: false,
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchReadmissionData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.baseUrl}/api/quicksight/readmission`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data && data.embedUrl) {
                this.setState({
                    readmissionQuickSightUrl: data.embedUrl,
                    loading: false,
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchAdtTrackingData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.baseUrl}/api/quicksight/adttracking`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data && data.embedUrl) {
                this.setState({
                    adtTrackingQuickSightUrl: data.embedUrl,
                    loading: false,
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchExecutiveEcmData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.baseUrl}/api/quicksight/ecmtracking`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data && data.embedUrl) {
                this.setState({
                    executiveEcmQuickSightUrl: data.embedUrl,
                    loading: false,
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchLeadershipData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.baseUrl}/api/quicksight/leadership`;

            const data = await getQuickSightUrl({
                url: apiUrl,
                server: this.props.settings.server,
            });

            if (data && data.embedUrl) {
                this.setState({
                    leadershipQuickSightUrl: data.embedUrl,
                    loading: false,
                });
            }

        } catch (error) {
            console.error("Failed to load QuickSight data:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    render() {
        return (
            <div className="page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />

                    <ViewDashboardHeader
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                        activeTab={this.state.activeTab}
                        onTabChange={this.handleTabChange}
                    />
                </div>

                <div className="patient-search-results">
                    {this.renderTabContent()}
                </div>
            </div>
        )
    }

    renderTabContent() {
        const { activeTab } = this.state;

        switch (activeTab) {
            case "populations":
                return this.renderPopulationContent();
            case "readmissions":
                return this.renderReadmissionContent();
            case "adttracking":
                return this.renderAdtTrackingContent();
            case "executiveecm":
                return this.renderExecutiveEcmContent();
            case "a1cdashboard":
                return this.renderA1cDashboardContent();
            case "leadership":
                return this.renderLeadershipContent();
        }
    }

    renderPopulationContent() {
        const { loading, error } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {this.state.populationQuickSightUrl &&
                        <iframe
                            id="populationDashboard"
                            title="Population Dashboard"
                            src={this.state.populationQuickSightUrl}
                            width="100%"
                            height="700"
                            style={{ border: "none" }}
                        ></iframe>
                    }
                </div>
            </>
        );
    }

    renderReadmissionContent() {
        const { loading, error } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {this.state.readmissionQuickSightUrl &&
                        <iframe
                            id="readmissionDashboard"
                            title="Readmission Dashboard"
                            src={this.state.readmissionQuickSightUrl}
                            width="100%"
                            height="700"
                            style={{ border: "none" }}
                        ></iframe>
                    }
                </div>
            </>
        );
    }

    renderAdtTrackingContent() {
        const { loading, error } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        return (
            <>
                <div className="tab-content-wrapper">
                    {this.state.adtTrackingQuickSightUrl &&
                        <iframe
                            id="adtTrackingDashboard"
                            title="ADT Tracking Dashboard"
                            src={this.state.adtTrackingQuickSightUrl}
                            width="100%"
                            height="700"
                            style={{ border: "none" }}
                        ></iframe>
                    }
                </div>
            </>
        );
    }

    renderExecutiveEcmContent() {
        const { loading, error } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {this.state.executiveEcmQuickSightUrl &&
                        <iframe
                            id="executiveEcmDashboard"
                            title="Executive ECM Dashboard"
                            src={this.state.executiveEcmQuickSightUrl}
                            width="100%"
                            height="700"
                            style={{ border: "none" }}
                        ></iframe>
                    }
                </div>
            </>
        );
    }

    renderLeadershipContent() {
        const { loading, error } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {this.state.leadershipQuickSightUrl &&
                        <iframe
                            id="leadershipDashboard"
                            title="Leadership Dashboard"
                            src={this.state.leadershipQuickSightUrl}
                            width="100%"
                            height="700"
                            style={{ border: "none" }}
                        ></iframe>
                    }
                </div>
            </>
        );
    }

    renderA1cDashboardContent() {
        return (
            <A1cDashboard
                query={this.props.query}
                settings={this.props.settings}
                location={this.props.location}
                urlParams={this.props.urlParams}
            />
        );
    }

}

export default connect(state => state)(withRouter(Dashboard));
